export const CAROUSEL_ARROW_WIDTH = 38;
export const CAROUSEL_OVERFLOW_FADE_WIDTH = 20;
